<template>
  <div
  class="wrapper page-login-content"
>
  <div class="login-wrapper">
      <div class="wrapper split-content d-flex justify-content-center">
        <div class="w-100">
          <div class="d-flex min-vh-100">
            <b-col
              class="min-vh-100 text-center d-none d-md-block col-6 left-side pl-0 pr-0">
              <div class="leftside-static-wrapper">
                <div class="leftside-static flex-column">
                  <div v-if="true" class="white-logo">
                    <a
                      :href="`/${$route.params.lang || ''}`"
                    >
                      <img :src="require('@/assets/interview-logo.png')" />
                    </a>
                  </div>
                  <reset-password-steps :isStepMode="isStepMode"></reset-password-steps>
                </div>
              </div>
            </b-col>
              <div
              v-if="isStepMode"
              :class="
                'forgot-password w-100 d-flex flex-column align-items-center justify-content-center split-layout-content' + (requestSended ? 'success-mail' : '')
              "
            >
              <div class="w-100 d-flex align-items-center reset-right">
                <div class="close-btn" @click="goToHome()">
                  <i class="icon-close" />
                </div>
              </div>
              <form-wrapper
              class="forgot-password-form"
              :header-text="resource['forgotPassword.ForgotPassHeaderText']"
              :desc="resource['forgotPassword.ForgotPassHeaderDescText']"
              :href="($route.params.lang === 'en' || !$route.params.lang) ? '/login' : `/${$route.params.lang}/login`"
              :button-text="requestSended ? resource['forgotPassword.ForgotPassHeaderDescText'] : resource['hrvenue.createCandidateSend']"
              :is-loading="isLoading"
              :disabled="requestSended"
              :enable-button="enableButton"
              @submit="forgotPassword"
              type="forgotPassword"
            >
            <validate-form
              id="userNameOrEmail"
              v-model="userNameOrEmail"
              rules="required|min:10|max:300|email"
              type="text"
              :name="resource['login.EmailFieldName']"
              :label="resource['login.EmailFieldName']"
              class-group="mb-3"
              :placeholder="resource['login.Username']"
              @keypress="maxLengthCheck($event, 300)"
              @keyup="maxLengthCheck($event, 300)"
              @click="removePlaceHolder('userNameOrEmail', userNameOrEmail)"
              @blur="removeTitleGroup('userNameOrEmail', userNameOrEmail)"
            />
          </form-wrapper>
            </div>
            <div  v-else :class="
            'forgot-password w-100 d-flex flex-column align-items-center justify-content-center split-layout-content' + (requestSended ? 'success-mail' : '')
          ">
              <div class="w-100 d-flex align-items-center reset-right">
                <div class="close-btn" @click="goToHome()">
                  <i class="icon-close" />
                </div>
              </div>
              <div class="forgot-password-form" style="text-align: center">
                <img class="sended-mail-icon" :src="require('@/assets/images/sended-mail.svg')" />
                <br />
                <h2>{{ resource["resetPassword.CheckYourEmailTitle"]}} </h2>
                <h5 class="m-0">
                  {{ resource["resetPassword.CheckYourEmailDesc"]}}
                </h5>
                <br />
                <h5 class="m-0">{{ resource["resetPassword.CheckYourEmailDescTwo"]}}</h5>
                <a class="resend-mail-link" @click="resendMail"> {{ resource["resetPassword.ResendButtonText"]}}</a>
              </div>
           </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { serviceWrapper, serviceConfigs } from '@/services/configs';
import formEvents from '@/utils/formEvents';

export default {
  name: 'ForgotPassword',
  layout: 'split',
  components: {
    FormWrapper: () => import('@/components/common/FormWrapper'),
    ResetPasswordSteps: () => import('../common/ResetPasswordSteps.vue'),
  },
  mixins: [formEvents],
  data() {
    return {
      userNameOrEmail: '',
      isLoading: false,
      requestSended: false,
      isStepMode: true,
    };
  },
  computed: {
    enableButton() {
      return this.userNameOrEmail.length > 0;
    },
  },

  methods: {
    async forgotPassword() {
      this.isLoading = true;
      const params = {
        email: this.userNameOrEmail,
      };
      serviceWrapper(
        serviceConfigs.account,
        serviceConfigs.account.forgotPassword,
        params,
      )
        .then(() => {
          this.requestSended = true;
          this.isStepMode = false;
        })
        .catch(() => {
          // dataLayer.push({
          //   Category: 'ForgotPassword',
          //   Action: 'Başarısız',
          //   Label: 'HatalıBilgi',
          //   event: 'gaEvent',
          // });
        })
        .finally(() => {
          this.requestSended = true;
          this.isStepMode = false;
          this.isLoading = false;
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'forgot_password_form_submit',
            page_type: 'forgot-password',
            site_type: 'interview',
          });
        });
    },

    setWhichInput(value) {
      this.userNameOrEmail = value;
    },
    maxLengthCheck(event, maxLength) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(value);
      } else {
        this.setWhichInput(value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
    resendMail() {
      this.isStepMode = true;
    },
    goToHome() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'HomeView', params: { lang } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.forgot-password {
  background: #FF8D06;

  @include media-breakpoint-down(sm) {
    background: #FFF;
    flex-direction: column;
  }
}
.close-btn {
  display: none;

  @include media-breakpoint-down(sm) {
    display:flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px;
    width: 100%;
  }

  i {
    display: none;
    font-size: 24px;

    @include media-breakpoint-down(sm) {
      display: block;
    }
  }
}
  .forgot-password-form {
    max-width: 360px;

    @include media-breakpoint-down(sm) {
      height: calc(100vh - 32px);
      width: 100%;
    }
  }
    .color-white {
      color: #fff;
    }
    #login-header-wrapper {
      position: absolute;
      top: 0;
      width: 100%;
      height: 60px !important;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
      z-index: 10;
      top: 0;
      background: #fff;
      @media screen and (max-height: 680px) {
        position: sticky !important;
        top: 0;
      }
    }
  @media screen and (max-height: 680px) {
    #login-header-wrapper {
      position: sticky !important;
      top: 0;
    }
    .header-fix {
      margin-top: 99px !important;
    }
    .leftside-static-wrapper {
      margin-top: 12px !important;
    }
  }
  .logo {
    height: 24px;
    background-image: url('https://img-kariyer.mncdn.com/sirius/images/knet-logo.svg');
    background-size: cover;
    width: 120px;
    @include media-breakpoint-down(sm) {
      height: 16px;
      width: 80px;
    }
  }
  .login-container {
    &.login-header {
      .signup-btn {
        &:hover {
          text-decoration: none;
          h5 {
            color: #fff;
          }
        }
      }
      .primary-button {
        padding: 20px 16px !important;
        h5 {
          font-size: 14px !important;
          color: purple;
        }
      }
    }
  }

  .left-side {
    flex-direction: column;
    justify-content: center;
    .persons-svg {
      width: 100%;
      max-width: 420px;
      margin-bottom: 55px;
    }
  }
  .seperator {
    width: 80%;
    height: 1px;
    background: #ecedf0;
    margin: 15px;
  }
  .seperator2 {
    margin: 16px auto;
    width: 100%;
    height: 1px;
    background: #ecedf0;
  }
  .btn {
    color: purple;

    &:hover {
      background: #FF8D06;
      color: white;
    }
  }

  .page-login-content {
    #chat-widget-container {
      display: none;
    }
    #cookie-info {
      position: fixed;
      bottom: 0;
      width: 100%;
      text-align: center;
      padding: 15px;
      background-color: rgba(0, 0, 0, 0.7);
      font-size: 14px;
      color: #ffffff;
      z-index: 999;
      i {
        float: right;
        cursor: pointer;
      }
      a {
        font-weight: bold;
        color: #ffffff;
        text-decoration: underline;
      }
    }
    .sign-up {
      background-color: rgba(82, 70, 97, 0.1);
    }
    .login-form {
      background: #f8f9fa;
      background-position: center !important;
      background-repeat: no-repeat !important;
      justify-content: center;
      align-items: center;
      background: white;
      @include media-breakpoint-down(sm) {
        background: white;
        justify-content: flex-start;
        align-items: flex-start;
      }

      .kariyer-logo {
        width: 225px;
        @include media-breakpoint-down(sm) {
          width: 138px;
          padding-top: 30px;
        }
        @include media-breakpoint-up(md) {
          padding-top: 30px;
        }
      }
      .login-align {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .login-header {
        margin: 16px 0;
      }
      .login-inputs {
        max-width: 360px;
        margin-left: auto;
        margin-right: auto;
        padding: 0px 24px 24px 24px;
        @include media-breakpoint-down(md) {
          margin-top: 0px;
          padding-top: 0px;
        }
        .header-text {
          color: #353535 !important;
          padding: 0px 16px 16px 16px;
          @include media-breakpoint-up(md) {
            color: inherit !important;
          }
        }
      }
    }
    .left-logo {
      background: #f8f9fa;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
  }

  .page-login {
    .page-login-content {
      display: block !important;
    }
  }
  .page-login-content {
    display: none;
  }

  .login-container {
    width: 1140px;
  }
  @media screen and (max-width: 1140px) and (min-width: 612px) {
    .login-container {
      width: 100%;
      padding: 0 40px;
    }
  }
  @media screen and (max-width: 612px) and (min-width: 375px) {
    .login-container {
      width: 100%;
      padding: 0 20px;
    }
  }
  @media screen and (max-width: 375px) {
    .login-container {
      width: 100%;
      padding: 0 16px;
    }
  }

    #login-header-wrapper {
      position: absolute;
      top: 0;
      width: 100%;
      height: 60px !important;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
      z-index: 10;
      top: 0;
      background: #fff;
      @media screen and (max-height: 680px) {
        position: sticky !important;
        top: 0;
      }
    }
    .login-wrapper {
      background: #fff;
      height: 100%;
      .left-side {
        display: flex !important;
        @media screen and (max-width: 1140px) {
          display: none !important;
        }
      }

      .white-logo {
        position: absolute;
        margin-top: -56px;
        left: 0;
        img {
          width: 260px;
        }
      }
      .leftside-static-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .leftside-static {
        display: flex;
        width: 388px;
        height: 388px;
        position: relative;
        transform-style: preserve-3d;
        #outer-circle {
          background: #9c44c4;
          border-radius: 50%;
          width: 353px;
          height: 353px;
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: translateZ(-10px);
          right: -96px;
          top: -131px;
        }
        #inner-circle {
          background: #FF8D06;
          border-radius: 50%;
          width: 67%;
          height: 67%;
        }
        .static-wrapper {
          transform-style: preserve-3d;
          width: 388px;
          height: 388px;
          .top-box-wrapper {
            padding: 62px 0px 0 0;

            .top-box {
              border-left: 2px solid #666666;
              padding-left: 32px;
              &-title {
                h1 {
                  font-weight: 900 !important;
                  font-size: 32px !important;
                  line-height: 130% !important;
                  color: #4C4C4C !important;
                  margin-bottom: 32px;
                }
              }
              &-desc {
                h2 {
                  font-weight: normal;
                  font-size: 20px !important;
                  line-height: 26px;
                  text-align: left;
                  max-width: 350px;
                  margin: 0;
                }
              }
            }
            .bottom-wrapper {
              text-align: left;
              display: flex;
              align-items: center;
              height: 97px;
              button {
                color: $purple;
                font-size: 14px;
                padding: 9px 16px;
              }
            }
          }
        }
      }
    }

    .login-form,
    .reset-password-form,
    .forgot-password-form {
      @media screen and (max-width: 612px) {
        width: 343px !important;
      }
      width: 360px;
      max-width: 100%;
      background: #fff;
      border-radius: 12px;
      padding: 0 16px 16px 16px;
      z-index: 1;
      margin-bottom: 20px;
      h2 {
        margin-bottom: 16px !important;
        margin-top: 20px;
      }
      .forgot-password-text {
        h6 {
          font-size: 14px !important;
        }
        color: $purple;
        &:hover {
          background-color: transparent !important;
          color: $secondary-purple !important;
          text-decoration: underline;
        }
      }
      .remember-me {
        margin: 10px 0 12px -6px !important;
        input {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
.forgot-password-steps-link {
  display: none;
  color: white;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: white;
  }
}
.header-fix.forgot-password {
  margin-top: 25px !important;

  &.success-mail {
    margin-top: 80px !important;
  }
}
@media screen and (max-width: 1140px) {
  .header-fix.forgot-password {
    margin-top: 0px !important;
    margin-bottom: 33px;
    &.success-mail {
      margin-top: 0px !important;
      margin-bottom: 0px;
    }
  }
  .forgot-password-steps-link {
    display: block;
  }
}
.resend-mail-link {
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  margin-top: 10px;
  color: $purple;
  &:hover {
    color: purple !important;
    text-decoration: underline;
  }
}
.sended-mail-icon {
  margin: 40px 0px 20px 0px;
}
  </style>
